import { reactive } from "vue";

export const store = reactive({
  email: "",
  politica: "",
  sexo: "",
  rotulo: "",
  bodyPart: "",
  gestante: "false",
  peleFrequencia: "",
  pele: "",
  peleTipo: "",
  faixaEtaria: "",
  sono: "",
  alimentacao: "",
  fumante: "",
  hidratacao: "",
  exercicios: "",
  estresse: "",
  tratamentos: "",
  tratamentosDescription: "",
  objetivos: [],
  essencia: "",
  base: "",
});
